import { eventChannel, END } from "redux-saga";
import { put, takeEvery, select, call, debounce } from "redux-saga/effects";

import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';
import { v4 } from "uuid";
import _ from "lodash";
import { Storage } from "aws-amplify";

import * as actions from "../actions";
import * as selectors from "../selectors/selectors";
import { handleApiError } from '../../utils/apiErrorHandler';
import { safeParseLocalStorage } from "../../utils/safeParseLocalStorage";

function* onFeatureClick(google, event) {
    yield put(actions.toggleFeatureInfoBox(true, event.latLng, event.feature, google));
}

const onGetProperties = (feature) => {
    return new Promise((resolve, reject) => {
        let properties = [];
        feature.forEachProperty(property => {
            properties.push(property);
        });
        resolve(properties);
    });
}

function* validateEditLayer(datalayer, action, event) {
    const editing = yield select(selectors.editing_customlayer);
    if (editing) {
        let feature = event.feature;
        const geodata = yield call(onConvertToGeoJSON, datalayer);

        let properties = yield onGetProperties(feature);
        const style = yield select(selectors.style_customlayer) || {};
        let props = _.merge(properties, style);
        let nuwefeature = {
            "type": "Feature",
            "properties": {
                ...props
            },
            "geometry": feature.getGeometry()
        };

        const size = new TextEncoder().encode(JSON.stringify(geodata)).length + new TextEncoder().encode(JSON.stringify(nuwefeature)).length;
        const kiloBytes = size / 1024;
        const megaBytes = kiloBytes / 1024;
        const gigaBytes = megaBytes / 1024;

        if (gigaBytes >= 4) {
            yield put(actions.editTempCustomLayerError(gigaBytes));
        }
        let log = {
            aksie: action,
            objek: "FEATURE",
            layer: editing.layer,
            version: editing.weergawe,
            feature: feature.getProperty("id")
        };
        yield put(actions.addCustomLayerLog(log));

        if (style) {
            datalayer.overrideStyle(feature, style);
            for (const [name, value] of Object.entries(style)) {
                feature.setProperty(name, value);
            }
        }
    }
}

export function* listenToFeatureClick(action) {
    const google = yield select(selectors.google);
    const clickChannel = eventChannel((emitter) => {
        action.datalayer.addListener('click', emitter);
        return () => action.datalayer.removeListener('click', emitter);
    });
    yield takeEvery(clickChannel, onFeatureClick, google);
}

const onKryGeoJson = (mapdata) => {
    return new Promise((resolve, reject) => {
        mapdata.toGeoJson(value => {
            resolve(value);
        });
    });
}

const onConvertToGeoJSON = (mapdata) => {
    return new Promise((resolve, reject) => {
        mapdata.toGeoJson(value => {
            resolve(value);
        });
    });
}

export function* validateLayer(action) {
    const geodata = yield call(onConvertToGeoJSON, action.datalayer);

    let properties = {};
    if (action.value?.getType() === "Point") {
        properties = {
            strokeColor: "#fff",
            strokeWeight: 1,
            strokeOpacity: 1,
            fillColor: "#000",
            fillOpacity: 1,
        };
    } else if (action.value?.getType() === "Polygon") {
        properties = {
            strokeColor: "#000",
            strokeWeight: 1,
            strokeOpacity: 1,
            fillColor: "#000",
            fillOpacity: 0.3,
        };
    } else if (action.value?.getType() === "LineString") {
        properties = {
            strokeColor: "#000",
            strokeWeight: 1,
            strokeOpacity: 1,
        };
    }
    let nuwefeature = {
        "type": "Feature",
        "properties": {
            ...properties
        },
        "geometry": action.value
    };

    const size = new TextEncoder().encode(JSON.stringify(geodata)).length + new TextEncoder().encode(JSON.stringify(nuwefeature)).length;
    const kiloBytes = size / 1024;
    const megaBytes = kiloBytes / 1024;
    const gigaBytes = megaBytes / 1024;

    if (gigaBytes >= 4) {
        yield put(actions.editTempCustomLayerError(gigaBytes));
    } else {
        yield put(actions.editTempCustomLayer(action.value, action.datalayer));
    }
}

export function* skepTempDrawLayer() {
    const google = yield select(selectors.google);
    const map = yield select(selectors.map);

    const datalayer = new google.maps.Data({
        map: map,
        controlPosition: google.maps.ControlPosition.TOP_RIGHT,
        controls: ["Point", "Polygon", "LineString"],
        drawingMode: "Point",
        featureFactory: geometry => {
            let properties = {
                iconPath: "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z",
                strokeColor: "#000",
                strokeWeight: 1,
                strokeOpacity: 1,
                fillColor: "#000",
                fillOpacity: 0.3,
            };
            let nuwefeature = {
                "properties": {
                    ...properties,
                    id: v4()
                },
                "geometry": geometry
            };
            return nuwefeature;
        },
        style: feature => {
            let icon = {};
            if (feature?.getGeometry()?.getType() === "Point") {
                icon = {
                    icon: {
                        path: feature.getProperty("iconPath") || "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z",
                        fillColor: feature.getProperty("fillColor"),
                        fillOpacity: feature.getProperty("fillOpacity"),
                        strokeColor: feature.getProperty("strokeColor"),
                        strokeWeight: feature.getProperty("strokeWeight"),
                        strokeOpacity: feature.getProperty("strokeOpacity"),
                        anchor: new google.maps.Point(12, 24),
                        scale: 1.5
                    }
                };
            }
            return {
                strokeColor: feature.getProperty("strokeColor"),
                strokeWeight: feature.getProperty("strokeWeight"),
                strokeOpacity: feature.getProperty("strokeOpacity"),
                fillColor: feature.getProperty("fillColor"),
                fillOpacity: feature.getProperty("fillOpacity"),
                ...icon,
                zIndex: 9998,
                clickable: true,
                editable: true,
                draggable: true
            };
        }
    });
    let layer = v4();
    let version = v4();

    const clickChannel = eventChannel((emitter) => {
        datalayer.addListener('click', emitter);
        return () => datalayer.removeListener('click', emitter);
    });
    yield takeEvery(clickChannel, onFeatureClick, google);

    const addChannel = eventChannel((emitter) => {
        datalayer.addListener('addfeature', emitter);
        return () => datalayer.removeListener('addfeature', emitter);
    });
    yield takeEvery(addChannel, validateEditLayer, datalayer, "ADD");

    const setGeometryChannel = eventChannel((emitter) => {
        datalayer.addListener('setgeometry', emitter);
        return () => datalayer.removeListener('setgeometry', emitter);
    });
    yield debounce(5000, setGeometryChannel, validateEditLayer, datalayer, "EDIT");

    const removeFeatureChannel = eventChannel((emitter) => {
        datalayer.addListener('removefeature', emitter);
        return () => datalayer.removeListener('removefeature', emitter);
    });
    yield takeEvery(removeFeatureChannel, validateEditLayer, datalayer, "REMOVE");

    yield put(actions.skepTempCustomLayer(datalayer, layer, version));
}

const kryCustomLayers = async () => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/layers/pasgemaak`;
        const response = await API.get(apiName, path, { response: true });
        // console.log(response);
        let data;
        if (response.status === 204) {
            data = [];
        } else {
            data = getResponseData(response, []);
        }
        return data;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

export function* getLayerslysSaga_custom() {
    try {
        var layers = yield kryCustomLayers();
        yield put(actions.setLayerslys_custom(layers));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getLayerslysFailed_custom(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

const kryLayerData = async (layer, version) => {
    try {
        const signedURL = await Storage.get(`${safeParseLocalStorage("boerdery", {}).boerderyuuid}/dashboard/layers/${layer}/${version}.geojson`, { expires: 1140 });
        return signedURL;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

const onLoadGeoJson = (datalayer, data) => {
    return new Promise((resolve, reject) => {
        datalayer.loadGeoJson(data, { idPropertyName: 'id' }, (features) => {
            resolve(features.length);
        });
    });
}

export function* kiesLayerSaga_custom(action) {
    try {
        const aktiewelayers = yield select(selectors.layersAkief_custom);
        const layers = yield select(selectors.layersmetadata_custom);
        if (aktiewelayers.indexOf(action.key) > -1) {
            let layer = layers.data.filter(item => item.id === action.key)[0];
            let version = _.sortBy(layer.weergawes, "id", "desc")[0];
            let data = yield kryLayerData(layer.id, version.id);
            const google = yield select(selectors.google);
            const map = yield select(selectors.map);
            const datalayer = new google.maps.Data({ map: map });
            let len = yield call(onLoadGeoJson, datalayer, data);
            yield put(actions.setLayerVersion_custom({ id: action.key, data: data, datalayer: datalayer, version: version.id, len: len }));
        }
    } catch (error) {
        console.log(error);
    }
}

export function* kiesLayerVersionSaga_custom(action) {
    try {
        const aktiewelayers = yield select(selectors.layersAkief_custom);
        const thislayers = yield select(selectors.layersmetadata_custom);
        if (aktiewelayers.indexOf(action.key) > -1) {
            let layers = thislayers.data.filter(item => item.id === action.key);
            for (const element of layers) {
                let aktieweversions = element.gekiesdeweergawes;
                if (aktieweversions.indexOf(action.version) > -1) {
                    let data = yield kryLayerData(action.key, action.version);
                    const google = yield select(selectors.google);
                    const map = yield select(selectors.map);
                    const datalayer = new google.maps.Data({ map: map });
                    let len = yield call(onLoadGeoJson, datalayer, data);
                    yield put(actions.setLayerVersion_custom({ id: action.key, data: data, datalayer: datalayer, version: action.version, len: len }));
                }
            }
        }
    } catch (error) {
        console.log(error);
    }
}

const onDoenAsync = (datalayer) => {
    return new Promise(async (resolve, reject) => {
        await datalayer.forEach((feature) => {
            datalayer.remove(feature);
        });
        datalayer.setControls(null);
        datalayer.setDrawingMode(null);
        resolve();
    });
}

const stoorS3 = async (layer, version, data) => {
    try {
        await Storage.put(
            `${safeParseLocalStorage("boerdery", {}).boerderyuuid}/dashboard/layers/${layer}/${version}.geojson`,
            JSON.stringify(data),
            {
                contentType: "application/geojson+json",
            });
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

const skepLogsAPICall = async (logs) => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/layers/pasgemaak/log`;
        let myInit = {
            response: true,
            body: {
                logs: logs
            },
        };
        const response = await API.post(apiName, path, myInit);
        return response;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

const skepNuweLayerAPICall = async (layer, body) => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/layers/pasgemaak`;
        let myInit = {
            response: true,
            body: {
                id: layer,
                naam: body.naam,
                tipe: body.tipe,
                weergawe: body.weergawe,
                weergawenaam: body.weergawenaam
            },
        };
        const response = await API.post(apiName, path, myInit);
        return response.data;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

const stoorVersionAPICall = async (layer, weergawe, naam) => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/layers/pasgemaak?layer=${layer}`;
        let myInit = {
            response: true,
            body: {
                weergawe: weergawe,
                naam: naam
            },
        };
        const response = await API.put(apiName, path, myInit);
        return response.data;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

const deleteVersionAPICall = async (layer, weergawe) => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/layers/pasgemaak?layer=${layer}&weergawe=${weergawe}`;
        await API.del(apiName, path, { response: true });
        return;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

function countdown(secs) {
    return eventChannel(emitter => {
        const iv = setInterval(() => {
            secs -= 1
            if (secs >= 0) {
                emitter(secs)
            } else {
                // this causes the channel to close
                emitter(END);
            }
        }, 1000);
        // The subscriber must return an unsubscribe function
        return () => {
            clearInterval(iv);
        }
    }
    )
}

export function* stoorLayer(action) {
    const drawingManager = yield select(selectors.drawingManager_customlayer);

    yield put(actions.skepCustomLayerLoading());
    const geodata = yield call(onKryGeoJson, action.datalayer);
    const editing = yield select(selectors.editing_customlayer);

    try {
        let layer = editing.layer;
        let version = editing.weergawe;
        yield stoorS3(layer, version, geodata);
        yield skepNuweLayerAPICall(layer, {
            naam: action.body.naam,
            tipe: action.body.tipe,
            weergawe: version,
            weergawenaam: action.body.weergawenaam
        });
        try {
            const logs = yield select(selectors.logs_customlayer);
            if (logs.length > 0) {
                yield skepLogsAPICall(logs);
            }
        } catch (error) {
            console.log(error);
        }
        yield put(actions.skepCustomLayerSuccess());

        const channel = yield call(countdown, 3);
        yield takeEvery(channel, function* (secs) {
            yield put(actions.skepCustomLayerTelling(secs));
            if (secs === 0) {
                yield call(onDoenAsync, action.datalayer, drawingManager);
                yield put(actions.skepCustomLayerClose(action.datalayer));
                yield put(actions.initKryLayerslys_custom());
            }
        });
        yield put(actions.clearCustomLayerLogs());
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.skepCustomLayerFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* stoorLayerVersionSaga_custom(action) {
    try {
        const drawingManager = yield select(selectors.drawingManager_customlayer);

        yield put(actions.stoorCustomLayerLoading());
        const editing = yield select(selectors.editing_customlayer);
        const geodata = yield call(onConvertToGeoJSON, action.datalayer);

        const google = yield select(selectors.google);
        google.maps.event.clearListeners(action.datalayer);

        var logs = yield select(selectors.logs_customlayer);

        if (action.nuweversion) {
            let version = v4();
            logs = logs.map(item => {
                return {
                    ...item,
                    version: version
                };
            });
            yield stoorS3(editing.layer, version, geodata);
            yield stoorVersionAPICall(editing.layer, version, action.naam);
            yield put(actions.stoorCustomLayerSuccessMessage());

            const channel = yield call(countdown, 3);
            yield takeEvery(channel, function* (secs) {
                yield put(actions.skepCustomLayerTelling(secs));
                if (secs === 0) {
                    yield call(onDoenAsync, action.datalayer, drawingManager);
                    yield put(actions.stoorNuweVersionCustomLayerSuccess());
                    yield put(actions.removeLayer_custom(editing.layer));
                    yield put(actions.initKryLayerslys_custom());
                }
            });
        } else {
            yield stoorS3(editing.layer, editing.weergawe, geodata);
            let data = yield kryLayerData(editing.layer, editing.weergawe);
            yield put(actions.stoorCustomLayerSuccessMessage());

            const channel = yield call(countdown, 3);
            yield takeEvery(channel, function* (secs) {
                yield put(actions.skepCustomLayerTelling(secs));
                if (secs === 0) {
                    if (drawingManager) {
                        drawingManager.setMap(null);
                    }
                    yield put(actions.stoorCustomLayerSuccess(data));
                    action.datalayer.setControls(null);
                    action.datalayer.setDrawingMode(null);
                }
            });
        }

        if (logs.length > 0) {
            try {
                yield skepLogsAPICall(logs);
            } catch (error) {
                console.log(error);
            }
        }
        yield put(actions.clearCustomLayerLogs());
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.stoorCustomLayerFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* kanselleerLayerVersionSaga_custom(action) {
    const drawingManager = yield select(selectors.drawingManager_customlayer);

    const google = yield select(selectors.google);
    google.maps.event.clearListeners(action.datalayer);
    yield call(onDoenAsync, action.datalayer, drawingManager);
    yield put(actions.clearCustomLayerLogs());
}

export function* resubscribeLayerVersionSaga_custom(action) {
    const drawingManager = yield select(selectors.drawingManager_customlayer);

    const google = yield select(selectors.google);
    google.maps.event.clearListeners(action.datalayer);
    yield call(onDoenAsync, action.datalayer, drawingManager);
    yield put(actions.clearCustomLayerLogs());

    const clickChannel = eventChannel((emitter) => {
        action.datalayer.addListener('click', emitter);
        return () => action.datalayer.removeListener('click', emitter);
    });
    yield takeEvery(clickChannel, onFeatureClick, google);
}

export function* deleteLayerVersionSaga_custom(action) {
    try {
        const drawingManager = yield select(selectors.drawingManager_customlayer);

        yield put(actions.deleteCustomLayerVersionLoading());
        const editing = yield select(selectors.editing_customlayer);
        const logs = yield select(selectors.logs_customlayer);

        yield deleteVersionAPICall(editing.layer, editing.weergawe);
        yield put(actions.deleteCustomLayerVersionSuccessMessage());

        const channel = yield call(countdown, 3);
        yield takeEvery(channel, function* (secs) {
            yield put(actions.skepCustomLayerTelling(secs));
            if (secs === 0) {
                yield put(actions.deleteCustomLayerVersionSuccess());
                yield call(onDoenAsync, action.datalayer, drawingManager);
                yield put(actions.initKryLayerslys_custom());
            }
        });

        if (logs.length > 0) {
            try {
                yield skepLogsAPICall(logs);
            } catch (error) {
                console.log(error);
            }
        }
        yield put(actions.clearCustomLayerLogs());
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.deleteCustomLayerVersionFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

const loadData = (datalayer, data) => {
    return new Promise((resolve, reject) => {
        datalayer.loadGeoJson(data, { idPropertyName: 'id' }, features => {
            resolve(features);
        });
    });
}

export function* maakEditableLayerVersionSaga_custom(action) {
    yield call(onDoenAsync, action.datalayer);

    const google = yield select(selectors.google);
    const map = yield select(selectors.map);

    const datalayer = new google.maps.Data({
        map: map,
        controlPosition: google.maps.ControlPosition.TOP_RIGHT,
        controls: ["Point", "Polygon", "LineString"],
        drawingMode: "Point",
        featureFactory: geometry => {
            let properties = {
                iconPath: "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z",
                strokeColor: "#000",
                strokeWeight: 1,
                strokeOpacity: 1,
                fillColor: "#000",
                fillOpacity: 0.3,
            };
            let nuwefeature = {
                "properties": {
                    ...properties,
                    id: v4()
                },
                "geometry": geometry
            };
            return nuwefeature;
        },
        style: feature => {
            let icon = {};
            if (feature?.getGeometry()?.getType() === "Point") {
                icon = {
                    icon: {
                        path: feature.getProperty("iconPath") || "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z",
                        fillColor: feature.getProperty("fillColor"),
                        fillOpacity: feature.getProperty("fillOpacity"),
                        strokeColor: feature.getProperty("strokeColor"),
                        strokeWeight: feature.getProperty("strokeWeight"),
                        strokeOpacity: feature.getProperty("strokeOpacity"),
                        anchor: new google.maps.Point(12, 24),
                        scale: 1.5
                    }
                };
            }
            return {
                strokeColor: feature.getProperty("strokeColor"),
                strokeWeight: feature.getProperty("strokeWeight"),
                strokeOpacity: feature.getProperty("strokeOpacity"),
                fillColor: feature.getProperty("fillColor"),
                fillOpacity: feature.getProperty("fillOpacity"),
                ...icon,
                zIndex: 9998,
                clickable: true,
                editable: true,
                draggable: true
            };
        }
    });

    const data = yield select(selectors.editlayer_resetdata_customlayer);
    yield loadData(datalayer, data);

    const clickChannel = eventChannel((emitter) => {
        datalayer.addListener('click', emitter);
        return () => datalayer.removeListener('click', emitter);
    });
    yield takeEvery(clickChannel, onFeatureClick, google);

    const addChannel = eventChannel((emitter) => {
        datalayer.addListener('addfeature', emitter);
        return () => datalayer.removeListener('addfeature', emitter);
    });
    yield takeEvery(addChannel, validateEditLayer, datalayer, "ADD");

    const setGeometryChannel = eventChannel((emitter) => {
        datalayer.addListener('setgeometry', emitter);
        return () => datalayer.removeListener('setgeometry', emitter);
    });
    yield debounce(5000, setGeometryChannel, validateEditLayer, datalayer, "EDIT");

    const removeFeatureChannel = eventChannel((emitter) => {
        datalayer.addListener('removefeature', emitter);
        return () => datalayer.removeListener('removefeature', emitter);
    });
    yield takeEvery(removeFeatureChannel, validateEditLayer, datalayer, "REMOVE");

    yield put(actions.setMakeVersionEditable_custom(action.layer, action.version, datalayer, data));
}

const stoorNaamAPICall = async (layer, naam) => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/layers/pasgemaak?layer=${layer}`;
        let myInit = {
            response: true,
            body: {
                naam: naam
            },
        };
        const response = await API.put(apiName, path, myInit);
        // console.log(response);
        return response.data;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

export function* stoorLayerNaamSaga_custom(action) {
    try {
        yield put(actions.stoorCustomLayerNameLoading());
        yield stoorNaamAPICall(action.layer, action.naam);
        yield put(actions.stoorCustomLayerNameSuccessMessage());
        const logs = yield select(selectors.logs_customlayer);

        const channel = yield call(countdown, 3);
        yield takeEvery(channel, function* (secs) {
            yield put(actions.skepCustomLayerTelling(secs));
            if (secs === 0) {
                yield put(actions.stoorCustomLayerNameSuccess());
                yield put(actions.initKryLayerslys_custom());
                yield put(actions.setLayerNaamEdit(null));
            }
        });

        if (logs.length > 0) {
            try {
                yield skepLogsAPICall(logs);
                yield put(actions.clearCustomLayerLogs());
            } catch (error) {
                console.log(error);
            }
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.stoorCustomLayerNameFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

const kryIcons = () => {
    return new Promise(async (resolve, reject) => {
        try {
            let data = await Storage.get(`data/json.txt`, { download: true });
            data = await data.Body.text();
            data = data.replace(")]}'", "");
            data = JSON.parse(data);
            data = data.icons;
            resolve(data);
        } catch (error) {
            console.log(error);
            const errordata = handleApiError(error, { context: 'saga' });
            console.log(errordata);
            reject(new Error(errordata.message || 'Iets het skeefgeloop...'));
        }
    });
}

export function* kryIconsCustomLayersSaga_custom(action) {
    try {
        let icons = yield kryIcons();
        yield put(actions.setIcons_CustomLayers(icons));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getIconsFailed_CustomLayers(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}